import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of, startWith, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Org } from '../model/org';
interface APIState<T> {
  loading: boolean,
  error: string | null,
  data: T | null,
}
@Injectable({
  providedIn: 'root'
})
export class Admin {
  constructor(
    private router:Router,
    private http:HttpClient
  ) { }

  headers = new HttpHeaders({
    "Content-Type":"application/json",
  })
  requestOptions = {headers :this.headers};


  createOrg(cred:any){
    return this.http.post<any>(`${environment.apiUrl}/auth/org` , cred)
    .pipe(catchError(this.errorHandle));
  }

  createUser(formData:any){
    return this.http.post<any>(`${environment.apiUrl}/auth/register` , formData)
    .pipe(catchError(this.errorHandle));
  }

  ssoLogin(formData:any){
    return this.http.post<any>(`${environment.apiUrl}/auth/sso`,formData)
    .pipe(catchError(this.errorHandle))
  }
 
  getOrgTypes(){
    return this.http.get<any>(`${environment.apiUrl}/auth/org/types` )
    .pipe(catchError(this.errorHandle));
  }

  getOrg(){
    return this.http.get<any>(`${environment.apiUrl}/auth/org` )
    .pipe(catchError(this.errorHandle));
  }
  
  getBuyerOrg(orgTypeId:number,rowNum:number,size:number):Observable<Org[]>{
    return this.http.get<Org[]>(`${environment.apiUrl}/auth/type/${orgTypeId}/orgs?rowNum=${rowNum}&size=${size}`)
    .pipe(catchError(this.errorHandle));
  }

  uploadProfilePic(profileData:any){
    return this.http.post<any>(`${environment.apiUrl}/media/file`,profileData,{
      reportProgress:true,
      responseType:"json",
    })
  }

  updateUserDetails(userDetails:any){
    return this.http.patch<any>(`${environment.apiUrl}/app/userdetails/update`,userDetails)
    .pipe(map(data => {
      return data;
    }));
   }

   createUserDetails(userDetails:any){
    return this.http.post<any>(`${environment.apiUrl}/app/userdetails/create`,userDetails)
    .pipe(map(data => {
      return data;
    }));
   }

   getMediaById(mediaId:any){
    return this.http.get(`${environment.apiUrl}/media/${mediaId}`,{
      responseType:"blob",
    })
   }


   getApplicationRoles(rowNum: number, size: number) {
 
    return this.http
      .get<any>(
        `${environment.apiUrl}/auth/applicationRoles?rowNum=` +
          rowNum +
          `&size=` +
          size,
        this.requestOptions
      )
      .pipe(catchError(this.errorHandle));
  }
  
  patchInvestorIntentStatus(intentId:number,intent:any){
    return this.http.patch<any>(`${environment.apiUrl}/investment/intent/${intentId}`,intent)
    .pipe(catchError(this.errorHandle));
  }

  getAdminDashboardStats() {
    return this.http.get<any>(`${environment.apiUrl}/auth/header`)
      .pipe(catchError(this.errorHandle));
  }

  getLeadAnalytics() {
    return this.http.get<any>(`${environment.apiUrl}/auth/test-crm-headers`)
      .pipe(catchError(this.errorHandle));
  }

  getCallbackRequestsList(rowNum:number,size:number,searchText:string,searchKey:string,sortOrder:string,sortKey:string,status:string){
    return this.http.get<any>(`${environment.apiUrl}/help-request?rowNum=${rowNum}&size=${size}&searchText=${searchText}&searchKey=${searchKey}&sortOrder=${sortOrder}&sortKey=${sortKey}&status=${status}`)
    .pipe(
      map((response:any)=>{
        return {
          data:response,
          loading:false,
          error:null
        }
      }),
      catchError((error:HttpErrorResponse)=>of({
        data:null,
        loading:false,
        error:error.error
      })),
      startWith({
        data:null,
        loading:true,
        error:null
      })
    );
  }

 

  patchCallbackRequest(id: number, payload: any) {
    return this.http.patch<any>(`${environment.apiUrl}/help-request/${id}`, payload)
      .pipe(catchError(this.errorHandle));
  }

  getImportPriceCalculatorDetails(id:any,formData:any){
    return this.http.post<any>(`${environment.apiUrl}/auth/calculate?id=${id}`,formData)
    .pipe(catchError(this.errorHandle))
  }
  
  errorHandle(error: any) {
    let errorMessage = "";
    if (error.error.error instanceof ErrorEvent) {
      errorMessage = error.error.error;
    } else {
      errorMessage = error.error;
    }

    return throwError(() => {
      return errorMessage;
    });
  }
}

